import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

/*ADMIN IMPORTS*/
import AdminLogin from "./admin/adminLogin";
import AdminDashboard from "./admin/adminDashboard";
import SidebarLayout from "./admin/sidebarLayout";
import AdminCreateUser from "./admin/adminCreateUser";
import AdminCreateClient from "./admin/adminCreateClient";
import AdminClientUserLink from "./admin/adminClientUserLink";
import AdminMessageToUsers from "./admin/adminMessageToUsers";
/* END ADMIN IMPORTS */

/*CLIENT IMPORTS*/
import ClientSidebarLayout from "./client/clientSidebarLayout";
import ClientLogin from "./client/clientLogin";
import ClientDashboard from "./client/clientDashboard";
import Form24Q from "./client/form24Q";
import Form26Q from "./client/form26Q";
import Form27EQ from "./client/form27EQ";
import FormGSTR1 from "./client/formGSTR1";
import FormGSTR7 from "./client/formGSTR7";
import UploadDocuments from "./client/uploadDocument";
import ChangePassword from "./admin/changePassword";
/* END CLIENT IMPORTS */

/*USER IMPORTS*/
import ReviewClientData from "./ca_user/reviewClientData";
import UserMessage from "./ca_user/userMessage";
import PrintReport from "../components/printReport";
import ClientUploadedDocs from "./ca_user/clientUploadedDocs";
/* END USER IMPORTS */

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* ADMIN ROUTES */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route element={<SidebarLayout />}>
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/admin-createuser" element={<AdminCreateUser />} />
          <Route path="/admin-createclient" element={<AdminCreateClient />} />
          <Route
            path="/admin-clientuserlink"
            element={<AdminClientUserLink />}
          />
          <Route path="/admin-message" element={<AdminMessageToUsers />} />
          {/* USER ROUTES */}
          <Route path="/review-data" element={<ReviewClientData />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/user-message" element={<UserMessage />} />
          <Route path="/print-gen-report" element={<PrintReport />} />
          <Route path="/client-document" element={<UploadDocuments />} />
          <Route
            path="/client-uploaded-docs"
            element={<ClientUploadedDocs />}
          />
        </Route>

        {/* CLIENT ROUTES */}
        <Route path="/" element={<ClientLogin />} />
        <Route element={<ClientSidebarLayout />}>
          <Route path="/client-dashboard" element={<ClientDashboard />} />
          <Route path="/client-form-24Q" element={<Form24Q />} />
          <Route path="/client-form-26Q" element={<Form26Q />} />
          <Route path="/client-form-27EQ" element={<Form27EQ />} />
          <Route path="/client-form-GSTR1" element={<FormGSTR1 />} />
          <Route path="/client-form-GSTR7" element={<FormGSTR7 />} />
          <Route path="/upload-document" element={<UploadDocuments />} />
          <Route path="/print-emp-report" element={<PrintReport />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;
